import * as React from 'react';
import styles from './Navbar.module.scss';
import { NavLink } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import { useState } from 'react';
import { TipsterRoutes, UserRoutes } from './Routes';
//assets
import logoB from '../../assets/logo-black-bg.svg';
import { MdMenu } from 'react-icons/md';
import defaultUserImage from '../../assets/icons/ic_avatar_default.svg';
import defaultTipsterImage from '../../assets/icons/ic_tipster_default.svg';
//tr
import { tr } from '../../utils/translations/translator';
import { useTranslation } from 'react-i18next';

export interface MobileNavbarProps {
  requestLogout: () => void;
  isTipster: boolean;
  user: any;
}

export const MobileNavbar: React.FC<MobileNavbarProps> = (props) => {
  const { t } = useTranslation();
  const { requestLogout, isTipster } = props;
  const [isBurgerOpen, setIsBurgerOpen] = useState(false);

  const constructUsername = (str: string): string => {
    if (str.length > 10) return `${str.slice(0, 9)}...`;
    else return str;
  };
  const SHOP_LOCATIONS = ['premium', 'tip'];
  const path = window.location.pathname;
  const isShopLocation = React.useMemo(
    () => SHOP_LOCATIONS.some((substring) => path.includes(substring)),
    [],
  );

  return (
    <>
      <div className={styles.padding}></div>
      <div className={styles.mobileNavbar}>
        <div className={styles.navbarLogo}>
          <SVG src={logoB} />
        </div>
        <div className={styles.rightSide}>
          <div className={styles.userInfo}>
            <img
              src={
                props.user.avatar_url || isTipster
                  ? defaultTipsterImage
                  : defaultUserImage
              }
              alt="Profile Avatar"
              className={styles.profilePic}
            />
          </div>

          <div
            className={styles.burgerMenuWrapper}
            onClick={() => setIsBurgerOpen(!isBurgerOpen)}
          >
            <MdMenu size={24} />
            {isBurgerOpen && (
              <div
                className={styles.closeBurgerOverlay}
                onClick={() => setIsBurgerOpen(false)}
              />
            )}
            <div
              className={
                isBurgerOpen ? styles.burgerMenu : styles.closedBurgerMenu
              }
              id={isShopLocation ? styles.withHeaderPadding : styles.unset}
            >
              <div className={styles.burgerItems}>
                {/* TIPSTER */}
                {isTipster
                  ? TipsterRoutes.map((section) => (
                      <div key={section.key} className={styles.routeSection}>
                        <p>{tr(t, section.key)}</p>
                        {section.routes.map((route) => {
                          return (
                            route.active && (
                              <div
                                className={styles.burgerItem}
                                key={route.key}
                              >
                                <NavLink
                                  to={route.path}
                                  activeClassName={styles.active}
                                  className={styles.nav}
                                  onClick={() => setIsBurgerOpen(false)}
                                >
                                  <p>{tr(t, route.key)}</p>
                                </NavLink>
                              </div>
                            )
                          );
                        })}
                      </div>
                    ))
                  : UserRoutes.map((route) => {
                      return (
                        route.active && (
                          <div className={styles.routeSection} key={route.key}>
                            <div className={styles.burgerItem}>
                              <NavLink
                                to={route.path}
                                activeClassName={styles.active}
                                className={styles.nav}
                                onClick={() => setIsBurgerOpen(false)}
                              >
                                <p>{tr(t, route.key)}</p>
                              </NavLink>
                            </div>
                          </div>
                        )
                      );
                    })}
                <div className={styles.logout} onClick={requestLogout}>
                  <p>{tr(t, 'logout')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
